import { TAppState } from '../../types/appState';
import { TOffer } from '../../types/offer';

export const offerSelector = (state: TAppState): TOffer | undefined => {
  const { chatWindow, chatList, openedChats } = state;
  const { currentOpenedChatId } = chatWindow;
  const { removedFromArchiveChatId, removedFromSpamChatId } = chatList;

  const chatId = (currentOpenedChatId || removedFromArchiveChatId || removedFromSpamChatId) as string;
  const chat = openedChats[chatId] || {};

  return chat.offer;
};
